import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function VenuesView() {
  const [venues, setVenues] = useState([]);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchVenues = async () => {
      const res = await fetch('/api/venues', { headers: { 'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json' } });
      if (res.ok) setVenues(await res.json());
    };
    fetchVenues();
  }, [token]);

  return (
    <div className="venues-view">
      <h2>🏟️ Venues</h2>
      <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead style={{ backgroundColor: '#f2f2f2' }}>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Description</th>
            <th>Live Music</th>
            <th>Dancefloor</th>
            <th>Live</th>
            <th>Music</th>
            <th>Location</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {venues.map(v => (
            <tr key={v.venue_id}>
              <td>{v.venue_id}</td>
              <td>{v.venue_name}</td>
              <td>{v.description}</td>
              <td>{v.live_music_ind ? 'Yes' : 'No'}</td>
              <td>{v.dancefloor_ind ? 'Yes' : 'No'}</td>
              <td>{v.live_ind ? 'Yes' : 'No'}</td>
              <td>{v.music_names ? v.music_names.join(', ') : ''}</td>
              <td>{v.location_name || ''}</td>
              <td>
                <Link to={`/dashboard/venues/edit/${v.venue_id}`}><button>Edit</button></Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Link to="/dashboard/venues/add"><button style={{ marginTop: '10px' }}>Add Venue</button></Link>
    </div>
  );
}

export default VenuesView;
